/**
 * bootprompt.js locale configuration
 * locale : Ukrainian
 * author : OlehBoiko
 */

import { addLocale } from "../bootprompt";

addLocale("uk", {
  OK: "OK",
  CANCEL: "Відміна",
  CONFIRM: "Прийняти",
});
